import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminActivity = (state: ApplicationRootState) =>
    state.admin.activity || initialState;

export const selectActivityList = createSelector(
    selectAdminActivity,
    (state) => state.list
);
